import Nav from "./Nav";
import PropTypes from "prop-types";
import classNames from "classnames";
import styles from "./Layout.module.css";
import { createContext } from "react";

export const CoreDataContext = createContext();

export default function Layout({ coreData, children, theme, style, pathName }) {
  return (
    <CoreDataContext.Provider value={coreData}>
      <div
        className={classNames({ [styles.Layout]: true, [styles[theme]]: true })}
        style={style}
      >
        <div className={styles.content}>
          <Nav pathName={pathName} />
          <main>{children}</main>
        </div>
      </div>
    </CoreDataContext.Provider>
  );
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
  style: PropTypes.object,
  theme: PropTypes.oneOf(["dark", "light"]).isRequired,
};
